<template>
  <div class="w-auto h-auto max-w-28 md:max-w-36 -my-3 md:-my-6">
    <UIEllieLogoLottie v-if="route.name !== 'get-in-touch'" :invert="isDark"/>
      
    <svg v-if="route.name === 'get-in-touch'" class="w-16 md:w-[9vw] lg:w-[5vw] h-auto translate-y-12 mix-blend-color	" viewBox="0 0 150 85" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M42.0075 84.9999H0V34.1522L82.9538 0H150V59.5849L42.0046 84.9999H42.0075ZM2.46065 82.5422H41.7282L147.545 57.6299V2.45772H83.4447L2.45772 35.7986V82.5422H2.46065Z" fill="currentColor"/>
      <path d="M17.6244 70.9268V41.9252H34.6255V44.6651H20.6436V54.8341H33.626V57.5358H20.6436V68.1839H34.6255V70.9239H17.6244V70.9268Z" fill="currentColor"/>
      <path d="M50.8447 63.2068V36.6041H47.8196V34.2081H53.7934V63.2097H50.8447V63.2068Z" fill="currentColor"/>
      <path d="M73.899 54.9017V28.299H70.8739V25.903H76.8477V54.9046H73.899V54.9017Z" fill="currentColor"/>
      <path d="M96.8387 46.626V28.1932H93.499V25.8354H99.7462V46.626H96.8387ZM95.3452 20.1292C95.3452 18.9503 96.0538 18.1242 97.4678 18.1242C98.8819 18.1242 99.5522 18.9503 99.5522 20.1292C99.5522 21.308 98.8848 22.1341 97.4678 22.1341C96.0508 22.1341 95.3452 21.308 95.3452 20.1292Z" fill="currentColor"/>
      <path d="M113.093 30.2129V29.6778C113.093 24.4566 116.256 19.2325 122.889 19.2325C129.521 19.2325 132.42 23.998 132.42 28.9546V30.4422H115.836C116.027 34.7873 118.314 38.2181 123.118 38.2181C126.625 38.2181 128.912 36.3865 129.409 34.1787H132.079C131.241 38.2181 127.925 40.7346 123.121 40.7346C116.145 40.7346 113.096 35.437 113.096 30.2129H113.093ZM115.951 28.2314H129.674C129.292 24.3802 126.966 21.752 122.889 21.752C118.811 21.752 116.486 24.4596 115.951 28.2314Z" fill="currentColor"/>
    </svg>
  </div>
</template>

<script setup>
const route = useRoute()
const target = 'dark-bg';
const darkHeader = [
  'get-in-touch',
  'works-kao-magiclean-assemble-your-magic-heroes',
  'works-simmons-world-class-sleep',
  'works-gryphon',
  'works-kdk-home-shower-series-3d-animation',
  'works-nus-brandvideo',
  'works-lazada',
  'works-singapore-cancer-society',
  'works-martell-noblidge',
]
const scrolled = ref(false)

const isDark = ref(false)
onMounted(() => {
  nextTick(() => {
    // StartIntersection(target);
  });
})

const StartIntersection = (target) => {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: Array.from({ length: 21 }, (_, i) => i * 0.05), // Generates [0.0, 0.05, 0.1, ..., 1.0]
  };

  const containers = document.querySelectorAll('.' + target); // Select ALL elements with the target class
  if (!containers.length) return; // Exit if no elements found

  const containerCallback = (entries) => {
    entries.forEach((entry) => { 
      if (entry.isIntersecting) {
        isDark.value = false;
      } else {
        isDark.value = true;
      }
    });
  };

  const containerObserver = new IntersectionObserver(containerCallback, options);

  containers.forEach((container) => containerObserver.observe(container)); // Observe each element
};

watch(() => route.name, 
  val => {
    nextTick(() => {
      StartIntersection(target);
    })
    
    if(darkHeader.includes(val)){
      isDark.value = false;
    } else {
      isDark.value = true;
    }
  }, 
  { immediate: true }
)

watch(() => scrolled.value, 
  val => {
    if(val){

    }
  }
)
</script>

<style lang="scss" scoped>
</style>